export const environment = {
  production: false,
  mockIdentity: false,
  apiUrl: 'http://localhost:5000',
  // apiUrl: '/api',
  oauth2Url: '/oauth2',
  // API of the Fortinet dashboard, served by the NetScope API (netscope/web/fortinet_blueprint.py) from the folder
  // 'fortinet_output_folder' of the environment (netscope/core/env)
  fortinetApiUrl: 'http://localhost:5000/fortinet'
  // apiUrl: "https://192.168.4.81/api"
};
